<ng-template
  #formular
  let-data
  >
  <div class="col mb-3">
    <span i18n="@@param-name">
      Wähle einen sprechenden Parameternamen, z.B.: <b>Suchwort</b>, <b>Person</b>, <b>Firma</b>
    </span>
    <input
      id="param-name"
      pInputText
      placeholder="Name"
      [(ngModel)]="data.key"
      (ngModelChange)="formularModelChange()"
      [ngModelOptions]="{ updateOn: 'blur' }"
      fluid
      >
  </div>
  <div class="col mb-3">
    <span i18n="@@param-description">
      Beschreibe der KI, wofür dieser Parameter verwendet wird. Z.B.: <b>Das Wort, nach dem gesucht werden
        soll</b>,
      <b>eine Person, die gefunden werden soll</b>, <b>Firma, zu der mehrere informationen geladen werden soll</b>
    </span>
  <p-inputgroup>
    <p-inputgroup-addon>
      <i
        class="ri-sparkling-fill text-primary"
        style="font-size: 1.2rem;"
      ></i>
    </p-inputgroup-addon>
    <input
      pInputText
      i18n-placeholder="@@description"
      placeholder="Beschreibung"
      [(ngModel)]="data.description"
      (ngModelChange)="formularModelChange()"
      [ngModelOptions]="{updateOn: 'blur'}"
      fluid
      >
  </p-inputgroup>
  <div class="mt-2"></div>
  <p-button
    type="button"
    severity="primary"
    (onClick)="selectedParamIndex = -1"
    label="Speichern"
    size="small"
    i18n-label="@@save"
    >
  </p-button>
</div>
@if (this.getSelectedParamState() === 'new') {
  <p-button
    severity="primary"
    size="small"
    (onClick)="this.addParamToList();"
    >
    <i class="ri-add-fill"></i>
    <span i18n="@@add">Hinzufügen</span>
  </p-button>
}
</ng-template>
@if (this.selectedTool) {
  <div class="row align-items-baseline">
    <div class="col">
      <h3
        class="mt-4"
        i18n="@@edit-search"
        >
        Suche bearbeiten
      </h3>
    </div>
    <div class="col-auto text-end">
      <app-skill-id-input
        [value]="this.selectedTool.skillId"
        (changed)="this.selectedTool.skillId = $event; this.saveToolConfig()"
      ></app-skill-id-input>
    </div>
    <div class="col-auto text-end pe-0">
      <p-toggleswitch
        [(ngModel)]="this.selectedTool.enabled"
        (ngModelChange)="this.saveToolConfig()"
      ></p-toggleswitch>
    </div>
  </div>
  <div class="row align-items-center mt-3">
    <div class="col-3">
      <span i18n="@@url">URL</span>
    </div>
    <div class="col">
      <input
        pInputText
        placeholder=""
        [(ngModel)]="this.selectedTool.url"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.saveToolConfig()"
        fluid
        >
    </div>
  </div>
  <p-divider
    align="left"
    styleClass="mt-4 mb-1"
  >
    <span
      class="text-muted small fw-semibold"
      i18n="@@ki-recognition"
    >KI-Erkennung</span>
  </p-divider>
  <div class="row align-items-center mt-3">
    <div class="col-3">
      <span i18n="@@description">Beschreibung</span>
    </div>
    <div class="col">
      <input
        pInputText
        [(ngModel)]="this.selectedTool.description"
        [ngModelOptions]="{updateOn: 'blur'}"
        (ngModelChange)="this.saveToolConfig()"
        fluid
        >
    </div>
  </div>
  <div class="row align-items-center mt-3">
    <div class="col-3">
      <span i18n="@@mode">Modus</span>
    </div>
    <div class="col">
      <p-select
        [options]="toolOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="this.selectedTool.tool"
        [ngModelOptions]="{updateOn: 'change'}"
        (ngModelChange)="this.saveToolConfig()"
        class="w-full"
        />
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-3">
      <span i18n="@@functionname">Funktionsname</span>
      <app-hint i18n="@@function-name-hint">
        Bitte wähle für deinen Skill einen sprechenden bzw. aussagekräftigen (Funktions)-Namen.
        Es sind max. <b>30 Zeichen</b> für einen Namen zulässig, sowie ausschließlich folgende Zeichen:
        <b>a-z</b>, <b>A-Z</b>, <b>0-9</b>, <b>-</b> und <b>_</b>.
      </app-hint>
    </div>
    <div class="col">
      <app-function-name-suggest
        [descriptionString]="this.selectedTool.description"
        (finish)="this.selectedTool.name = $event; this.saveToolConfig();"
        >
        <input
          pInputText
          i18n-placeholder="@@name"
          placeholder="Name"
          maxlength="30"
          [(ngModel)]="this.selectedTool.name"
          [ngModelOptions]="{updateOn: 'blur'}"
          (ngModelChange)="this.rss.checkFunctionName(this.selectedTool.name) && this.saveToolConfig();"
          fluid
          >
      </app-function-name-suggest>
    </div>
  </div>
  <h3
    class="mt-5"
    i18n="@@param"
  >Parameter</h3>
  <div
    class="mb-3"
    [@.disabled]="true"
    >
    <p-message
      severity="secondary"
      i18n="@@web-param-description"
      >Hier kannst du Parameter konfigurieren, die an die aufgerufene Website übergeben
      werden. Diese Parameter ermöglichen
      es, dynamische Inhalte oder benutzerdefinierte Daten an die Zielseite zu übermitteln.
    </p-message>
  </div>
  <div class="row ">
    @if (this.paramForNewForm) {
      <div
        class="col p-5"
        style="border-left: 4px solid #00A599;"
        >
        <ng-template
          [ngTemplateOutlet]="formular"
          [ngTemplateOutletContext]="{ $implicit: this.paramForNewForm }"
          >
        </ng-template>
      </div>
    }
    @if (!this.paramForNewForm) {
      <div class="col">
        <p-button
          severity="primary"
          size="small"
          (click)="this.selectEmptyParam()"
          >
          <i class="ri-add-fill"></i>
          <span i18n="@@add">Hinzufügen</span>
        </p-button>
      </div>
    }
  </div>
  @if (this.selectedTool.params.length > 0) {
    <h5
      class="mt-4"
      i18n="@@entered-variables"
    >Eingetragene Variablen</h5>
  }
  <p-table
    [value]="selectedTool.params"
    [tableStyle]="{ 'min-width': '100%' }"
    >
    <ng-template
      pTemplate="body"
      let-param
      let-rowIndex="rowIndex"
      >
      <tr [ngClass]="{ 'bg-selected-row': selectedParam === param }">
        @if (selectedParam !== param) {
          <td>
            <i class="ri-braces-line"></i> {{ param.key }}&nbsp;
          </td>
          <td>
            <span>
              <b i18n="@@example-title">Beispiel:</b>
              {{ selectedTool.url }}?param={{ '{' + param.key + '}' }}
            </span>
          </td>
        }
        @if (selectedParam === param) {
          <td
            colspan="2"
            class="p-5"
            >
            <ng-template
              [ngTemplateOutlet]="formular"
              [ngTemplateOutletContext]="{ $implicit: selectedParam }"
            ></ng-template>
          </td>
        }
        @if (selectedParam !== param) {
          <td class="text-end">
            <p-button
              type="button"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              [raised]="true"
              icon="ri ri-more-2-fill"
              (onClick)="openParamMenu($event, paramMenu, rowIndex)"
              >
            </p-button>
            <p-menu
              #paramMenu
              [popup]="true"
              appendTo="body"
              [baseZIndex]="9000"
              [model]="paramContextMenuItems"
            ></p-menu>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
}
